var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Card",
    { attrs: { "dis-hover": true } },
    [
      _c(
        "Tabs",
        {
          attrs: { animated: false, "capture-focus": true },
          model: {
            value: _vm.pageType,
            callback: function ($$v) {
              _vm.pageType = $$v
            },
            expression: "pageType",
          },
        },
        [
          _c(
            "TabPane",
            { attrs: { label: "总监", name: "inspector" } },
            [
              _vm.pageType === "inspector"
                ? _c("DeptMemberInspectorList")
                : _vm._e(),
            ],
            1
          ),
          _c(
            "TabPane",
            { attrs: { label: "客户经理项目人", name: "cusMgrLeader" } },
            [
              _vm.pageType === "cusMgrLeader"
                ? _c("DeptMemberCusMgrLeaderList")
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }